export class FormElementSummary {
  public Name: string;
  public Guid: string;
  public Selected: boolean;

  public constructor(itemName?: string, itemGuid?: string, itemSelected?: boolean) {
    if (itemName == null || itemName == undefined) {
      this.Name = '';
    } else {
      this.Name = itemName;
    }
    if (itemGuid == null || itemGuid == undefined) {
      this.Guid = '';
    } else {
      this.Guid = itemGuid;
    }

    if (itemSelected == null || itemSelected == undefined) {
      this.Selected = null;
    } else {
      this.Selected = itemSelected;
    }
  }
}
